export default __webpack_public_path__ + "static/media/262-united kingdom.37c072bd.svg";